import { Box, Image } from "@chakra-ui/react";
import lanterns from "../images/lanterns.png";

/**
 * @description 燈籠裝飾元件(三個一組)
 * @returns {JSX.Element}
 */
const Lanterns = () => {
  return (
    <Box
      pointerEvents={"none"}
      top={"-14rem"}
      left={"-10rem"}
      position={"fixed"}
      display={{ base: "none", xl: "block" }}
    >
      <Image src={lanterns} alt="New Year Lanterns" transform={"scale(0.5)"} />
    </Box>
  );
};

export default Lanterns;
